import React from 'react';
import { Legend } from 'recharts';
import { Colors } from '@inplayer-org/inplayer-ui';

// utils
import formatNumber from 'utils/formatNumber';

// component
import { LegendContainer } from 'pages/MerchantPages/Analytics/Subscriptions/SubscriptionsMap';

// A generic function that takes 4 arguments and returns a legend for data that is not available:
// keyFilter and keyFilterValue- filter the array based on the keyName which has the value of keyFilterValue (it could be N/A, '' or info not available)
// dataNotAvailableNumber - the value of the data that is not available
// data - the data we get back from a request

export const customLegend = <T extends any>(
  keyFilter: string,
  keyFilterValue: string,
  dataNotAvailableNumber: string,
  data?: T[]
) => {
  if (!data) return null;
  const dataNotAvailable: T[] = data.filter((el: T) => el[keyFilter] === keyFilterValue);

  if (dataNotAvailable[0]) {
    return (
      <LegendContainer>
        <Legend
          payload={[
            {
              id: 1,
              value: `Not available: ${formatNumber(dataNotAvailable[0][dataNotAvailableNumber])}`,
              type: 'square',
              color: Colors.navy,
            },
          ]}
        />
      </LegendContainer>
    );
  }
};

export default customLegend;
